import { useUser } from '../providers/UserProvider';
import { useToast } from '../providers/ToastProvider';
import { apiErrorMessage } from '../utils/apiError';
import { useAssignDmNotificationPatient } from './useDmNotificationMutations';

// Inline assign/unassign for a Monitoring > Notifications patient row; mirrors useCommunicationAssignment.
export function useDmNotificationAssignment(patientId: string) {
    const { user } = useUser();
    const { showToast } = useToast();
    const assignMutation = useAssignDmNotificationPatient();

    const setAssignee = async (email: string | null) => {
        try {
            await assignMutation.mutateAsync({ patientId, email });
            showToast(email ? 'Patient assigned' : 'Patient unassigned', 'success');
        } catch (error) {
            const fallback = email ? 'Failed to assign patient.' : 'Failed to unassign patient.';
            showToast(apiErrorMessage(error, fallback), 'error');
        }
    };

    return {
        currentUserEmail: user?.email ?? '',
        handleAssign: (email: string) => void setAssignee(email),
        handleUnassign: () => void setAssignee(null)
    };
}
